import "./style.css"

interface IContainerProps extends React.HTMLAttributes<HTMLElement> {}

export const Container = (props: IContainerProps) => {
  return <div {...props} className={`container ${props.className ?? ""}`} />
}
